import { decamelizeKeys } from 'humps';

import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { BatchAddGroupNodePayload } from './types';

export const batchAddNodes = async (
  payload: BatchAddGroupNodePayload,
  options: ServiceRequestConfig = {},
) => {
  await managedEntities.post(
    '/nodes/batch-add',
    decamelizeKeys(payload),
    options,
  );
};
